// removed by extract-text-webpack-plugin
module.exports = {"App":"br1Ee8KLvyB9Xv6jPbV-g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/style.css
// module id = 280
// module chunks = 0